import * as React from "react";
import styles from "../ChartDialogCommon.module.scss";
import { Stack } from "@mui/system";
import { getDynamicPercentageBy, itemPercentage } from "../../../../utilis/common";
import { Button, useMediaQuery } from "@mui/material";
import { CHART_POINT_TYPE } from "../../../../types/chart-dialog.type";
import _ from "lodash";
import { useSelector } from "react-redux";

export default function ChartTotalContainer({
    total,
    censusAverage,
    title,
    subtitle,
    handleChartLabelType,
    isChartTotalButton,
    chartPointType,
    isTotalText = true,
    dbData
}) {
    const { percentageBy } = useSelector((state) => state.common);
    const isMobile = useMediaQuery('(max-width: 768px)');
    
    const percentageAgainst = React.useMemo(() => {
		return getDynamicPercentageBy(dbData, percentageBy);
	}, [percentageBy, dbData]);
    
    if (isMobile) {
        return (
            <>
                {isTotalText && (
                    <Stack 
                        direction={isMobile ? "row" : "column"} 
                        spacing={isMobile ? 1 : 0.5}
                        sx={{
                            padding: '4px 8px',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '4px',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            minWidth: 'fit-content',
                            ...(isMobile && {
                                flexWrap: 'wrap',
                                rowGap: 0.5,
                                alignItems: 'center',
                                justifyContent: 'flex-start'
                            })
                        }}
                    >
                        {isChartTotalButton && (
                            <Stack direction={"row"} spacing={0.5} justifyContent="center">
                                <Button
                                    size="small"
                                    variant={chartPointType === CHART_POINT_TYPE.TOTAL ? "contained" : "outlined"}
                                    onClick={() => handleChartLabelType(CHART_POINT_TYPE.TOTAL)}
                                    sx={{
                                        fontSize: '10px',
                                        padding: '2px 6px',
                                        minWidth: '40px',
                                        height: '24px'
                                    }}
                                >
                                    Total
                                </Button>
                                <Button
                                    size="small"
                                    variant={chartPointType === CHART_POINT_TYPE.PERCENTAGE ? "contained" : "outlined"}
                                    onClick={() => handleChartLabelType(CHART_POINT_TYPE.PERCENTAGE)}
                                    sx={{
                                        fontSize: '10px',
                                        padding: '2px 6px',
                                        minWidth: '60px',
                                        height: '24px'
                                    }}
                                >
                                    Percentage
                                </Button>
                            </Stack>
                        )}
                        <Stack direction={"row"} spacing={1} alignItems="center">
                            <span style={{ fontSize: '11px', color: '#666' }}>{title}:</span>
                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{total}</span>
                        </Stack>
                        {!_.isEmpty(censusAverage) && censusAverage.length > 0 && (
                            <Stack direction={"row"} spacing={1} alignItems="center">
                                <span style={{ fontSize: '10px', color: '#666' }}>{percentageBy}:</span>
                                <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                    {itemPercentage(total, percentageAgainst, "percentage")}
                                </span>
                            </Stack>
                        )}
                    </Stack>
                )}
            </>
        );
    }
    
    return (
        <>
            {isTotalText && (
                <Stack direction={"row"} className={styles.totalContainer}>
                    {isChartTotalButton && (
                        <Stack direction={"row"} spacing={1} justifyContent="flex-end" sx={{ mr: 1 }}>
                            <Button
                                size="small"
                                variant={chartPointType === CHART_POINT_TYPE.TOTAL ? "contained" : "outlined"}
                                onClick={() => handleChartLabelType(CHART_POINT_TYPE.TOTAL)}
                                sx={{
                                    textTransform: "none",
                                    fontWeight: 600,
                                    borderRadius: "6px"
                                }}
                            >
                                Total
                            </Button>
                            <Button
                                size="small"
                                variant={chartPointType === CHART_POINT_TYPE.PERCENTAGE ? "contained" : "outlined"}
                                onClick={() => handleChartLabelType(CHART_POINT_TYPE.PERCENTAGE)}
                                sx={{
                                    textTransform: "none",
                                    fontWeight: 600,
                                    borderRadius: "6px"
                                }}
                            >
                                Percentage
                            </Button>
                        </Stack>
                    )}
                    <div className={styles.metricCard}>
                        <div className={styles.metricValue}>{total}</div>
                        <div className={styles.metricLabel}>{title}</div>
                    </div>
                    {!_.isEmpty(censusAverage) && censusAverage.length > 0 && (
                        <div className={styles.metricCard}>
                            <div className={styles.metricValue}>
                                {itemPercentage(total, percentageAgainst, "percentage")}
                            </div>
                            <div className={styles.metricLabel}>{percentageBy}</div>
                        </div>
                    )}
                </Stack>
            )}
        </>
    );
}
